import { collection } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";
import { firebaseHelper } from "ui";
import { isStaging } from "./environments";
import { reportFirestoreDenials } from "./firestoreDenials";

const useStaging = isStaging();
reportFirestoreDenials();
export { useStaging };

export const templateUserID = useStaging ? 'A6n1gfkdQtZDZ2ZA429EmjJod4J2' : 'HLVIWplaT4cqYhrx213kDIozdI93'
export const curatedTemplateUserID = useStaging ? '16WeGcOwD4dQc0G38NOjgp5TJoJ3' : 'py1hSLQqgbVBd59uYVMEcTLX4nI3'
export const curatedImagesUserId = useStaging ? 'pQsaHDNWVMMueRutIkN9jG7TQur1' : 'AoHdX1W5ZOgYgXh6S5OVnG5blGC3'
export const typesenseApiKey = useStaging ? 'Mb26vLBvxv5XfprfIq9MFxdGEHLWbUIw' : 'wlECOgKcFkuRUaWlNTSE01RA9q63aV3y'
export const typesenseHost = useStaging ? '5em0syz9xui4gra1p-1.a1.typesense.net' : 'vsgxbl8mn9k5o61up.a1.typesense.net'
export const toneMapDynamicObjectsFlag = false;
export const USERPILOT_TOKEN = useStaging ? "STG-NX-ff98d37c" : "NX-ff98d37c";
export const CIO_WRITE_KEY = useStaging ? "e0248d5f5e6db15bf004" : "5707670631c3ef5bcc50";
export const TEAMS_INVITATION_LINK = useStaging ? "https://sendteaminvitations-829457126264.us-central1.run.app" : "https://send-team-invitations-709632310154.us-central1.run.app";

// Supabase configuration — Mattoboard 2 project
// Staging (localhost, daily, previews): "staging" branch - xmzqwcnuldctszogryec
// Production (mattoboard.com, beta): main - okrombfhyvgomtagvyjx
// Old projects (rollback): staging glfevldtqujajsalahxd / prod pdzfdkixmzjolgihgznf
//   old prod key: sb_publishable_FoIripUxW2Fp9T6yBpv07Q_tgISMo2O
export const supabaseUrl = useStaging
  ? 'https://xmzqwcnuldctszogryec.supabase.co'
  : 'https://okrombfhyvgomtagvyjx.supabase.co';
export const supabasePublishableKey = useStaging
  ? 'sb_publishable_bT3e3hXON0g1vzCs7JWMwA_-lawkoms'
  : 'sb_publishable_ww3dm-U1aCr8V2ZSkkJIZg_pMtMNE9L';

// FREE vs PRO deck (Oct 2026): every curated template is Pro apart from these 13.
// Staging has none of them, so all its curated templates show as Pro.
export const freeCuratedTemplateIDs = useStaging
  ? []
  : [
      "jl4vwba2we", // Sea Breeze
      "q11a7w3uho", // Melbourne Living
      "113dx61fuk", // Verdant Crush
      "sscfn2y05l", // Sugar Dust
      "8e236yg8zg", // Maroon Kitchen
      "siwxk5vmbn", // Sage Chestnut
      "v68cnwq2xc", // Forest Calm
      "jmn3vcweap", // Parisian Living Area
      "j7k5r0n1vf", // Matcha
      "yuunqvyyzo", // Brisbane Kitchen
      "gigzfrcgjd", // Modern Oasis
      "ysx26tbp8d", // Minimal Hallway
      "7s8zkh9qtz", // Blue Geometric
    ];

export const proBlankTemplateIDs = useStaging
  ? []
  : [
      "55r2ie75tg",
      "bay8qf5qng",
      "5kv9kupnea",
      "6f8h19ivg2",
      "9nnv6oz7nz",
      "a1q1w49nft",
      "ci0x3jluee",
      "e26ycce7ra",
      "fd49gsziz9",
      "e6zlfg4ys1",
      "gfc6jlg5nd",
      "gr5ikxitvg",
      "gt40xy5x2k",
      "6n8m5k9719",
      "msgfe76zd2",
      "nl6mhb76uo",
      "r2jaf16ezw",
      "rx6zcbi9gp",
      "s4bexqcz0c",
      "su6ml0i7x4",
      "tt9jkmp5cw",
      "uhl9ixgzp1",
      "vejhsxsj78",
      "xapj9ikpfk",
      "20qyhd5um0",
      "bo8jppbm13",
      "6zwwg2b1xg",
      "8fvs8a4txk",
      "bucd9qqs6e",
      "18it6m7y6w",
      "y9qy33jsgb",
      "e0giefkuth",
      "ic2pu5gqzd",
      "qns6mne1rq",
      "jkv4eh2b04",
      "r9kdsoatke",
      "1z48ghncrm",
    ].sort();

export const MAX_FREE_RENDERS = 1;
export const MAX_FREE_UPLOADS = 10;
export const MAX_FREE_MATERIALS = 10;
export const MAX_FREE_PROJECTS = 5;

//['7bpk5ud1ri','85lz8f2n7h','2rnoz9dxn4','2t9w3fo94w','yhy2ppdjip','s9per0maly','tnvhdjsygi','z5ew3br6cm','qv65c1zlbc','8j4sf0tdix','yjc5konr3a','j257nwhgbe','sbsdwnpss9','tqybj12a7q','tu1xn17ty5','em1oftuldn','faf72k1ous','4333z7gh94','3jwbjw0guk','hmxvphyszv','o3x7pue7t1','1vzvqp8lzf','9axhx7fqit',
//'capbrdeeeh','iz9xtuaekd','776smeb3tt','1ups0ws1dv','2rs9o5613z', '3bw30ro1bi','4xg7637nwy', '5c0mnj91c9', '9rqb79u0n2', 'aqnfkuit37', 'jravnyf2uy','21f0zpy5ms','9ec55ixbob','em4mdii75a', 'irgx3pp81s', 'm5k0i5nxi1', 'nwof60i0bg', 'szbvu14pzr', 'u79lme4y1g','vafsqz7wxc', 'x2xsspm3a9', 'z0seqbbz6d'].sort()

const firebaseConfigProduction = {
  apiKey: "AIzaSyCTGdYrK9O7Vt2DpG3aqMi-9Kux3uKPEvA",
  //authDomain: "mattoboard-b8284.firebaseapp.com",
  authDomain: "mattoboard.com",
  projectId: "mattoboard-b8284",
  storageBucket: "mattoboard-b8284.appspot.com",
  messagingSenderId: "709632310154",
  appId: "1:709632310154:web:ceeb0aa750d8c2d3e12673",
  measurementId: "G-0SZ3V9684H",
  databaseURL: "https://mattoboard-b8284-default-rtdb.firebaseio.com/"
};
const firebaseConfigStaging = {
  apiKey: "AIzaSyAt-1lkI-PZaYeP4uQvLhYCJbWRU1DpzZU",
  // authDomain: "mattoboard-staging.firebaseapp.com",
  // authDomain: "mattoboard-staging.web.app",
  authDomain: "auth.mattobeta.uk",
  projectId: "mattoboard-staging",
  storageBucket: "mattoboard-staging.appspot.com",
  messagingSenderId: "829457126264",
  appId: "1:829457126264:web:4593809c2b4fa145a46e8d",
  databaseURL: "https://mattoboard-staging-default-rtdb.firebaseio.com/" 
  //measurementId: "${config.measurementId}"
};
export const firebaseConfig = useStaging
  ? firebaseConfigStaging
  : firebaseConfigProduction;

/*
Adapters to the now shared library in ui + some legacy variables.
*/
export let googleSignup = firebaseHelper.googleSignup;
export let microsoftSignup = firebaseHelper.microsoftSignup;
export let sendResetPassword = firebaseHelper.sendResetPassword;
export let resetPassword = firebaseHelper.resetPassword;
export let getDocByID = firebaseHelper.getDocByID;
export let getUrlFromRef = firebaseHelper.URLFromRef;
export let getPublicURL = firebaseHelper.publicURL;
export let updateRecord = firebaseHelper.updateRecord;
export let updateFieldsInRecord = firebaseHelper.updateFieldsInRecord;
export let uploadAndSave = firebaseHelper.uploadAndSave;
export let uploadAndSave2 = firebaseHelper.uploadAndSave2;
export let uploadImageToStorage = firebaseHelper.uploadImageToStorage;
export let createNewVersion = firebaseHelper.createNewVersion;
export let deleteOldestVersion = firebaseHelper.deleteOldestVersion;
export let getVersionById = firebaseHelper.getVersionById;
export let getVersionHistory = firebaseHelper.getVersionHistory;
export let updateVersionTitle = firebaseHelper.updateVersionTitle;
export let deleteVersion = firebaseHelper.deleteVersion;

export let deleteRecordAndFiles = firebaseHelper.deleteRecordAndFiles;
export let uploadFileToGCloud = firebaseHelper.uploadFileToGCloud;
export let getProductCache = firebaseHelper.getProductCache;

//export const storageURL = useStaging ? 'mattoboard-staging.appspot.com' : 'mattoboard-b8284.appspot.com'

// //export const firebaseApp = initializeApp(useStaging ? firebaseConfigStaging : firebaseConfig)
export let firebaseApp = null;
export let analytics = null;
export let permissionsDB = null;
export let projectsDB = null;
export let projectsSchemeDB = null;
export let productsDB = null;
export let profilesDB = null;
export let userImagesDB = null;
export let userFavoritesDB = null;
export let userCollectionsDB = null;
export let ffeSchedulesDB = null;
export let userProductsDB = null;
export let userProductFiltersDB = null;
export let userImageFiltersDB = null;
export let suppliersDB = null;
export let notificationsDB = null;
export let notificationsViewedDB = null;
export let storageURL = null;
export let deepRenderDB = null;
export let dsImgIterationDB = null;
export let firebaseDB = null;

export const setupHelpers = () => {
  firebaseApp = firebaseHelper.firebaseApp;
  const db = firebaseHelper.db;
  firebaseDB = db;

  isSupported().then((result) => {
    if (result) {
      analytics = getAnalytics(firebaseApp);
    }
  });

  projectsDB = collection(db, "projects");
  permissionsDB = collection(db, "permissions");
  projectsSchemeDB = collection(db, "projectsScheme");
  productsDB = collection(db, "productsV2");
  profilesDB = collection(db, "profiles");
  userImagesDB = collection(db, "userImages");
  userProductsDB = collection(db, "userProducts");
  userProductFiltersDB = collection(db, "userProductFilters");
  userImageFiltersDB = collection(db, "userImageFilters");
  userFavoritesDB = collection(db, "userFavorites");
  userCollectionsDB = collection(db, "usersMyCollection");
  ffeSchedulesDB = collection(db, "ffeSchedules");
  deepRenderDB = collection(db, "deepRender");
  suppliersDB = collection(db, "suppliers");
  notificationsDB = collection(db, "notifications");
  notificationsViewedDB = collection(db, "notifications_viewed");
  dsImgIterationDB = collection(db, "dsImgIteration");
  storageURL = firebaseApp.options.storageBucket;
  googleSignup = firebaseHelper.googleSignup.bind(firebaseHelper);
  microsoftSignup = firebaseHelper.microsoftSignup.bind(firebaseHelper);
  sendResetPassword = firebaseHelper.sendResetPassword.bind(firebaseHelper);
  resetPassword = firebaseHelper.resetPassword.bind(firebaseHelper);
  getDocByID = firebaseHelper.getDocByID.bind(firebaseHelper);
  getUrlFromRef = firebaseHelper.URLFromRef.bind(firebaseHelper);
  getPublicURL = firebaseHelper.publicURL.bind(firebaseHelper);
  updateRecord = firebaseHelper.updateRecord.bind(firebaseHelper);
  uploadAndSave = firebaseHelper.uploadAndSave.bind(firebaseHelper);
  uploadAndSave2 = firebaseHelper.uploadAndSave2.bind(firebaseHelper);
  deleteRecordAndFiles =
    firebaseHelper.deleteRecordAndFiles.bind(firebaseHelper);
  uploadFileToGCloud = firebaseHelper.uploadFileToGCloud.bind(firebaseHelper);
  getProductCache = firebaseHelper.getProductCache.bind(firebaseHelper);
  deleteOldestVersion = firebaseHelper.deleteOldestVersion.bind(firebaseHelper);
  getVersionById = firebaseHelper.getVersionById.bind(firebaseHelper);
  getVersionHistory = firebaseHelper.getVersionHistory.bind(firebaseHelper);
  createNewVersion = firebaseHelper.createNewVersion.bind(firebaseHelper);
  updateVersionTitle = firebaseHelper.updateVersionTitle.bind(firebaseHelper);
  deleteVersion = firebaseHelper.deleteVersion.bind(firebaseHelper);
};
